const Text = {
  navTitle: "College Rank",
  homeTitle: "College Rank",
  homeDescription:
    "College Rank is a platform that helps EAPCET AND TS EAMCET students find the right college for their needs. We provide information on colleges and courses to help students make informed decisions.",
  faq: {
    Title: "Frequently Asked Questions",
    Q1: "How accurate are the college predictions?",
    A1: "Our predictions are based on previous years' closing ranks data. They provide a good estimate, but actual cutoffs may vary each year based on seat availability and applicant preferences.",
    Q2: "Can I save my college selections?",
    A2: "Yes! Create an account to save your favorite colleges, create multiple lists, and access them from anywhere. You can also share your lists with friends and family.",
    Q3: "What does the color coding mean?",
    A3: "Green indicates colleges where your rank makes admission likely, yellow indicates moderate chances, and red suggests ambitious choices where admission may be challenging.",
  },

  WhyUs: {
    Title: "Why Choose Us?",
    Title1: "Complete College List",
    Title2: "Smart Search",
    Title3: "Save & Share",
    Description1:
      "Access comprehensive database of colleges from both AP EAMCET and TS EAMCET counseling.",
    Description2:
      "Get personalized college suggestions with our advanced prediction algorithm based on previous year data.",
    Description3:
      "Save your favorite colleges, create custom lists and share them with friends and family.",
  },
  RankPredictor: {
    Title: "Rank Predictor",
    Description:
      "Estimate your EAMCET rank based on your marks and get a quick idea of your admission chances in Andhra Pradesh and Telangana engineering colleges.",
    AP: {
      Title: "AP EAMCET Rank Predictor",
      Description:
        "Estimate your AP EAMCET rank based on your marks and get a quick idea of your admission chances in Andhra Pradesh and Telangana engineering colleges.",
    },
    TS: {
      Title: "TS EAMCET Rank Predictor",
      Description:
        "Estimate your TS EAMCET rank based on your marks and get a quick idea of your admission chances in Telangana engineering colleges.",
    },
  },

  InputHeadings: "Search Colleges",
  CollegeRank: "College Rank",
  CreateList: "Create List",
  Searching: "Searching.....",
  AvailableColleges: "Available Colleges",
  ImportantNote:
    "Important: These college recommendations are based on previous year's cut-off ranks and serve as a reference only. Cut-off ranks can change significantly each year.",
  Dismiss: "Dismiss",
  NoColleges:
    " No colleges found for your criteria. Try adjusting your rank or category.",
  NoBranch: "No branches found ",

  Filter: {
    Title: "Find Colleges",
    Description: "! Select your preferred colleges below.",
    Loading: "LLoading college data...",
    AvailableColleges: "Available Colleges",
    SelectedColleges: "Selected Colleges",
    SaveAndProceed: "Save and Proceed",
  },
  Login: {
    Title: "Login",
    WelcomeBack: "Welcome Back!",
    Description: "Login to your account",
    SignUp: "Create an account",
    EmailorPhone: "Email or Phone Number",
    Password: "Password",
    ForgotPassword: "Forgot Password?",
    SigningIn: "Signing in...",
    Donthaveanaccount: "Don't have an account?",
    SignUpNow: "Sign Up Now",
    //error??
  },
  PrintPdf: {
    Title: "Print PDF",
    Description:
      "Click the button below to download your college list as a PDF.",
    Success: "Success!",
    Note1: "You can still edit and update your list in your profile.",
    Ok: "OK",
    CollegeSelectionReport: "College Selection Report",
    StudentInfo: "Student Information",
    Gender: "Gender : ",
    Category: "Category : ",
    Rank: "Rank : ",
    SelectedColleges: "Selected Colleges",
    Oops: "Oops!",
    Note2:
      " It appears you haven't selected any colleges or the data couldn't be retrieved. Please go back and add colleges to your list, then proceed again.",
    GeneratedOn: "Generated on:",
    GeneraingPdf: "Generating PDF...",
    DownloadPdf: "Download PDF...",
  },
  Profile: {
    Title: "Profile",
    Description:
      "Manage your account settings, view your saved college lists, and update your personal information.",
    Suggestion: "  Access your profile and saved college lists by logging in.",
    Loading: "Loading profile data...",
    PleaseWait: "Please wait a moment...",
    YourLists: "Your Saved College Lists",
    NoLists: "You have no saved college lists.",
    CreateNewList:
      "Create your first college list to save your selections and share them with others.",
    CreateListLink: "Create Your First List",
    LocationRequired: "Location Required",
    LocationDescription:
      "Please provide your place and district to edit your college list.",
  },
  SharedList: {
    Loading: "Loading shared list...",
    PleaseWait: "Please wait while we fetch the information...",
    ListNotFound: "List not found",
    ListNotFoundDescription:
      "The shared list you are looking for does not exist or has been removed.",
    NoColleges: "No colleges found in this list.",
    NoCollegesDescription:
      "The shared list you are looking for does not contain any colleges.",
  },

  WhatsNew: {
    Hero: {
      Title: "Latest Updates",
      Description:
        "Discover our new features designed to make your college selection process more accurate and personalized",
      ButtonText: "Try New Features",
    },
    SafetyMargin: {
      Title: "New Safety Margin Feature",
      Description:
        "We've introduced a powerful new feature to help you make more informed decisions about your college choices. The Safety Margin feature allows you to adjust the range of colleges shown based on their cut-off ranks relative to your own rank.",
      WhyMatters: {
        Title: "Why This Matters",
        Description:
          "Since college cut-off ranks vary yearly due to factors like applicant numbers and seat availability, the Safety Margin feature gives you flexibility to consider colleges slightly beyond your rank that might still be attainable, while clearly indicating your chances of admission.",
      },
      HowItWorks: {
        Title: "How Safety Margin Works",
        Safe: {
          Title: "Safe (0-10%)",
          Description:
            "Colleges where the closing ranks are higher than your rank. These colleges offer a high chance of admission.",
        },
        Moderate: {
          Title: "Moderate (11-20%)",
          Description:
            "Colleges where the closing ranks are slightly below your rank. Admission here is possible but not guaranteed.",
        },
        Ambitious: {
          Title: "Ambitious (21-30%)",
          Description:
            "Colleges where the closing ranks are significantly below your rank. These are more challenging but still possible.",
        },
      },
      Example: {
        Title: "Example Scenario",
        Intro: "For a student with rank 5000:",
        Safe: "Safe (0-10%): Shows colleges with closing ranks from 5000 to 5500. These are highly achievable options.",
        Moderate:
          "Moderate (11-20%): Expands to colleges with closing ranks from 4500 to 4999. Admission is feasible but less certain.",
        Ambitious:
          "Ambitious (21-30%): Includes colleges with closing ranks from 4000 to 4499, where admission is tougher but possible.",
      },
      HowToUse: {
        Title: "How to Use the Safety Margin",
        Step1:
          "Enter your rank, gender, and caste to generate your eligible colleges list",
        Step2: "Find the Safety Margin slider in the filtering section",
        Step3:
          "Adjust the slider to your preferred risk level, from Safe to Ambitious",
        Step4:
          "Watch as your college list updates instantly to reflect your chosen margin",
      },
    },
    OtherImprovements: {
      Title: "Other Improvements",
      Security: {
        Title: "Enhanced Security",
        Description:
          "We've improved our authentication system to use HTTP-only cookies for better security and protection of your account information.",
      },
      Authentication: {
        Title: "Improved Authentication",
        Description:
          "Sign in with either email or phone number for more flexibility, with stronger password requirements for better account protection.",
      },
      Mobile: {
        Title: "Mobile Optimization",
        Description:
          "Enhanced mobile experience with responsive filters, better list management, and smoother navigation on smaller screens.",
      },
      TSEAMCET: {
        Title: "TS EAMCET Support",
        Description:
          "Added support for Telangana EAMCET colleges, allowing students to access both AP and TS college data in one platform.",
      },
    },
    ComingSoon: {
      Title: "More Updates Coming Soon",
      Description:
        "We're continuously working to improve your experience and add new features. Stay tuned for additional updates and enhancements!",
      ButtonText: "Try New Features Now",
    },
  },

  TermsAndConditions: {
    Hero: {
      Title: "Terms and Conditions",
      Description:
        "Important information about using our College Eligibility and Selection Tool",
    },
    TermsOfService: {
      Title: "Terms of Service",
      Welcome: {
        Title: "Welcome to College Rank",
        Description:
          'Welcome to College Rank, a web-based tool designed to assist students in exploring and prioritizing college options based on previous years\' EAMCET cut-off ranks. By accessing or using our website, you agree to comply with and be bound by the following Terms of Service ("ToS"). Please read them carefully. If you do not agree with these terms, you should not use our website.',
      },
      Sections: {
        Purpose: {
          Title: "1. Purpose of the Website",
          Description:
            "College Rank provides a reference tool that uses historical cut-off ranks from previous years to help students identify eligible colleges, filter options, and prioritize their preferences. The data is for informational purposes only and does not guarantee admission or reflect current year cut-offs.",
        },
        Acceptance: {
          Title: "2. Acceptance of Terms",
          Description:
            "By using our website, you agree to these Terms of Service and any updates we may post. We reserve the right to modify these terms at any time, and changes will be effective upon posting. Your continued use of the website after updates constitutes acceptance of the revised terms.",
        },
        Eligibility: {
          Title: "3. Eligibility",
          Items: [
            "You must be at least 13 years old to use this website.",
            "If you are under 18, you should use the website under the supervision of a parent or guardian.",
          ],
        },
        UserResponsibilities: {
          Title: "4. User Responsibilities",
          Items: [
            {
              Title: "Accuracy of Information:",
              Description:
                "You are responsible for providing accurate information (e.g., rank, gender, caste) when using the tool. We are not liable for incorrect results due to inaccurate inputs.",
            },
            {
              Title: "Account Security:",
              Description:
                "If you create an account, you must keep your login credentials secure and not share them with others. Notify us immediately if you suspect unauthorized use of your account.",
            },
            {
              Title: "Lawful Use:",
              Description:
                "You agree to use the website only for lawful purposes and in accordance with these terms.",
            },
          ],
        },
        DataLimitations: {
          Title: "Data Limitations and Predictions",
          Items: [
            {
              Title: "Historical Data Based Predictions",
              Description: "Our college predictions and recommendations are based solely on previous years' cut-off ranks and historical data. These predictions may not be completely accurate and should not be considered final or guaranteed."
            },
            {
              Title: "Reference Only",
              Description: "The information provided by CollegeRank should be used for reference purposes only. Users should not make critical decisions based solely on our predictions."
            },
            {
              Title: "No Liability",
              Description: "CollegeRank is not responsible for any issues, losses, or complications arising from decisions made based on our predictions or recommendations. Users are advised to verify all information with official sources."
            }
          ]
        },
        IntellectualProperty: {
          Title: "6. Intellectual Property",
          Items: [
            "All content on College Rank, including text, design, code, and features, is owned by us or our licensors and is protected by copyright and other intellectual property laws.",
            "You may not copy, modify, distribute, or reproduce any part of the website without our written permission, except for personal, non-commercial use as intended (e.g., downloading your college list as a PDF).",
          ],
        },
        Privacy: {
          Title: "7. Privacy",
          Description:
            "Your use of the website is also governed by our Privacy Policy. We collect and use your data only as necessary to provide our services and improve your experience.",
        },
        LimitationOfLiability: {
          Title: "8. Limitation of Liability",
          Items: [
            {
              Title: "",
              Description:
                'College Rank is provided "as is" without warranties of any kind. We are not responsible for:',
              SubItems: [
                "Errors or inaccuracies in the cut-off data.",
                "Decisions you make based on the website's information.",
                "Any loss or damage arising from your use of the website.",
              ],
            },
            {
              Title: "",
              Description:
                "We are not liable for interruptions in service due to technical issues or maintenance.",
            },
          ],
        },
        Termination: {
          Title: "9. Termination",
          Description:
            "We may suspend or terminate your access to the website at our discretion if you violate these terms or engage in harmful behavior (e.g., spamming, hacking).",
        },
        ContactUs: {
          Title: "10. Contact Us",
          Description:
            "If you have questions about these Terms of Service, please contact us at support@collegerank.in.",
        },
        LastUpdated: {
          Title: "Last Updated",
          Date: "April 7, 2025",
        },
      },
    },
    TermsAndConditionsSection: {
      Title: "Terms and Conditions",
      Sections: {
        Introduction: {
          Title: "1. Introduction",
          Description:
            'These Terms and Conditions ("T&C") govern your use of College Rank, a tool that helps students explore college options using previous years\' cut-off ranks as a reference. By using our website, you agree to these terms in full.',
        },
        UseOfWebsite: {
          Title: "2. Use of the Website",
          Items: [
            {
              Title: "Permitted Use:",
              Description:
                "You may use the website to input your rank, gender, and caste; filter and prioritize colleges; and save, share, or download your college list.",
            },
            {
              Title: "Prohibited Use:",
              Description: "You may not:",
              SubItems: [
                "Use the website to harm others or violate laws.",
                "Attempt to hack, reverse-engineer, or disrupt the website.",
                "Use automated tools (e.g., bots) to scrape data without permission.",
              ],
            },
          ],
        },
        ServiceDescription: {
          Title: "3. Service Description",
          Items: [
            {
              Title: "College Listing:",
              Description:
                "We provide a list of colleges based on historical cut-off ranks, which you can filter by university type, location, branch, and Safety Margin settings.",
            },
            {
              Title: "Features:",
              Description:
                "You can prioritize colleges, save lists to your profile, rename or update them, share them with others, and download them as PDFs.",
            },
            {
              Title: "Reference Only:",
              Description:
                "The data is from past years and intended as a guide, not a promise of current eligibility or admission.",
            },
          ],
        },
        UserGeneratedContent: {
          Title: "4. User-Generated Content",
          Items: [
            "Any data you input (e.g., rank, preferences) or lists you create remain your responsibility. By sharing lists, you grant us permission to store and display them as needed to provide the service.",
            "We may remove any content you create that violates these terms (e.g., offensive list names).",
          ],
        },
        ThirdPartyLinks: {
          Title: "5. Third-Party Links",
          Description:
            "If our website links to external sites (e.g., college websites), we are not responsible for their content, accuracy, or practices.",
        },
        FeesAndPayments: {
          Title: "6. Fees and Payments",
          Description:
            "College Rank is currently free to use. If we introduce paid features in the future, we will notify you and provide updated terms.",
        },
        Disclaimers: {
          Title: "Disclaimers and Limitations",
          Items: [
            {
              Title: "Prediction Accuracy",
              Description: "Our college predictions and seat availability forecasts are based on historical data from previous years' cut-off ranks. These predictions are not guaranteed to be accurate and should not be considered as final or official information."
            },
            {
              Title: "Reference Purpose",
              Description: "The website and its services are provided for reference purposes only. Users should not make critical educational decisions based solely on the information provided by CollegeRank."
            },
            {
              Title: "No Guarantee",
              Description: "CollegeRank does not guarantee admission to any college or institution based on our predictions. Users should always verify information with official sources and consult with appropriate educational authorities."
            },
            {
              Title: "Disclaimer of Responsibility",
              Description: "CollegeRank explicitly disclaims all responsibility for any issues, problems, or complications that may arise from decisions made based on our predictions or recommendations. Users use the service at their own risk."
            },
            {
              Title: "College Recommendations",
              Description: "While we strive to provide comprehensive college selection guidance and recommend diversifying college choices across different rank ranges for better counseling purposes, the final admission outcome depends on various factors including but not limited to actual rank, seat availability, and official counseling process. Our recommendations are advisory in nature and should not be considered as guarantees of admission. Users are encouraged to make informed decisions based on their individual circumstances and official counseling guidelines."
            }
          ]
        },
        Indemnity: {
          Title: "8. Indemnity",
          Description:
            "You agree to indemnify and hold College Rank, its creators, and affiliates harmless from any claims, damages, or losses arising from your use of the website or violation of these terms.",
        },
        GoverningLaw: {
          Title: "9. Governing Law",
          Description:
            "These Terms and Conditions are governed by the laws of India. Any disputes will be resolved in the courts of appropriate jurisdiction in India.",
        },
        ChangesToTerms: {
          Title: "10. Changes to Terms",
          Description:
            "We may update these Terms and Conditions at any time. The updated version will be posted on this page, and your continued use of the website signifies your agreement to the changes.",
        },
        ContactInformation: {
          Title: "11. Contact Information",
          Description:
            "For questions or concerns about these Terms and Conditions, reach out to us at support@collegerank.in.",
        },
        EffectiveDate: {
          Title: "Effective Date",
          Date: "April 7, 2025",
        },
      },
    },
    ReturnToHome: "Return to Home",
  },
  Contact: {
    Title: "Contact Us",
    Description:
      "We value your feedback and inquiries. Please fill out the form below to get in touch with us.",
    Name: "Name",
    Email: "Email",

    Message: "Message",
    SendMessage: "Send Message",
    Sending: "Sending...",
    ThankYou: "Thank you for reaching out!",
    ThankYouDescription:
      "We appreciate your message and will get back to you as soon as possible.",
  },

  SafetyMarginSlider: {
    Title: "Safety Margin:",
    InfoButtonAriaLabel: "More information about safety margin",
    Labels: {
      Safe: "Safe",
      Moderate: "Moderate",
      Ambitious: "Ambitious",
    },
    InfoPanel: {
      Title: "How Safety Margin Works",
      Safe: {
        Title: "0-10% (Safe):",
        Description:
          "Colleges where closing ranks are higher than your rank. You have a good chance of admission.",
      },
      Moderate: {
        Title: "11-20% (Moderate):",
        Description:
          "Colleges where closing ranks are slightly below your rank. Admission possible but not guaranteed.",
      },
      Ambitious: {
        Title: "21-30% (Ambitious):",
        Description:
          "Colleges where closing ranks are significantly below your rank. More challenging to secure admission.",
      },
      CurrentSetting:
        "Current Setting: Showing colleges within {margin}% of your rank {belowRankText}.",
    },
  },

  WarningAlert: {
    Warning: "Warning!",
    Message:
      "Make sure you save each and every time you update the list, and also save before you proceed to the next page.",
    DismissAriaLabel: "Dismiss",
  },
  CollegeList: {
    Title: "College List",
    Description: "Select colleges based on your preferences and eligibility.",
    NoCollegesFound: "No colleges found for the selected criteria.",
    NoCollegesFoundDescription: "Try adjusting your rank or category.",
    Loading: "Loading college data...",
    PleaseWait: "Please wait while we fetch the information...",
  },
  SelectedList: {
    Title: "Selected Colleges",
    Description: "You have selected {count} colleges.",
    NoCollegesSelected: "No Colleges Selected",
    NoCollegesSelectedDescription:
      "Your selection will appear here. Add colleges from the list on the left.",
  },
  About: {
    Hero: {
      Title: "Your Path to College Success",
      Description:
        "College Rank is an intelligent tool designed to help students discover, compare, and select the best colleges based on their EAMCET rank, preferences, and eligibility criteria.",
      ButtonText: "Get Started",
    },
    AboutPlatform: {
      Title: "About Our Platform",
      Description1:
        "The College Eligibility and Selection Tool simplifies the college selection process for students preparing for EAMCET counseling. Instead of manually checking thousands of colleges against your rank and category, our platform instantly shows you eligible options based on your specific criteria.",
      Description2:
        "Whether you're looking for colleges in a specific location, focusing on particular branches, or trying to assess your chances based on previous year's cutoffs, our tool provides a personalized, efficient way to make one of the most important decisions of your academic career.",
    },
    KeyFeatures: {
      Title: "Key Features",
      Features: [
        {
          IconColor: "blue",
          Title: "Smart Eligibility Checking",
          Description:
            "Enter your EAMCET rank, gender, and category to instantly see colleges where you're eligible for admission based on previous cutoff data.",
        },
        {
          IconColor: "green",
          Title: "Advanced Filtering",
          Description:
            "Filter colleges by location, branch, college type, and more to narrow down your options and find the perfect match for your preferences.",
        },
        {
          IconColor: "purple",
          Title: "Personalized College Lists",
          Description:
            "Create and customize college selection lists, prioritize your choices, and save multiple lists for different scenarios.",
        },
        {
          IconColor: "yellow",
          Title: "Share and Export",
          Description:
            "Share your college lists with family and counselors via unique links, and download PDF versions for offline reference.",
        },
      ],
    },
    HowItWorks: {
      Title: "How It Works",
      Steps: [
        {
          Number: 1,
          Title: "Enter Your Details",
          Description:
            "Provide your EAMCET rank, gender, caste, and other preferences in the simple form on our homepage.",
        },
        {
          Number: 2,
          Title: "Browse Eligible Colleges",
          Description:
            "View a comprehensive list of colleges where you're eligible for admission based on previous year's cutoff ranks.",
        },
        {
          Number: 3,
          Title: "Create Your Selection List",
          Description:
            "Add colleges you're interested in to your personal selection list. Reorder them based on your preferences.",
        },
        {
          Number: 4,
          Title: "Save and Share",
          Description:
            "Save your list to your account, download it as a PDF, or share it with others via a unique link.",
        },
      ],
    },
    WhyChoose: {
      Title: "Why Choose College Rank",
      Reasons: [
        {
          Icon: "personalized",
          Title: "Personalized Experience",
          Description:
            "Get college recommendations tailored specifically to your rank, gender, and category.",
        },
        {
          Icon: "time",
          Title: "Time-Saving",
          Description:
            "Find eligible colleges in seconds instead of spending days researching cutoffs manually.",
        },
        {
          Icon: "data",
          Title: "Data-Driven Decisions",
          Description:
            "Make informed choices based on accurate previous year cutoff data and intelligent risk assessment.",
        },
      ],
    },
    CTA: {
      Title: "Ready to Find Your Perfect College?",
      Description:
        "Get started today and discover the colleges where you have the best chances of admission based on your rank and preferences.",
      ButtonText: "Start Your College Search",
    },
  },
};

export default Text;
